import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Global axios defaults: 15s timeout so a stalled mobile network fails fast
// instead of leaving the UI in a silent spinner state.
axios.defaults.timeout = 15000;

// Same-origin rewrite: when the frontend is served from a different host than the
// baked REACT_APP_BACKEND_URL (e.g. custom domain `repticraft.co.uk` hitting a bundle
// baked with `enclosure-craft-1.emergent.host`), rewrite the absolute backend URL
// to a relative path. The reverse proxy on the custom domain forwards `/api/*`
// to the backend on the SAME origin, sidestepping any cross-origin CORS preflight
// failure. In preview (where REACT_APP_BACKEND_URL === window.location.origin),
// this interceptor is a no-op.
const BAKED_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
if (
  typeof window !== "undefined" &&
  BAKED_BACKEND &&
  !window.location.origin.startsWith(BAKED_BACKEND) &&
  !BAKED_BACKEND.startsWith(window.location.origin)
) {
  axios.interceptors.request.use((config) => {
    if (config.url && config.url.startsWith(BAKED_BACKEND)) {
      config.url = config.url.slice(BAKED_BACKEND.length) || "/";
    }
    return config;
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
